import { NavLink } from "react-router";
import { useLookupDemandesQuery } from "../../stores/OkOkStore";
import { type Demande, type DemandeParameters, type demandeStatus } from "../../types/Demande";
import { formatDate } from "../../tools/utils";

import Pager from "../Common/Pager";
//import { useState } from "react";
import ProfilListItem from "../Common/ProfilListItem";
import ProfilDisplay from "../Common/ProfilDisplay";
import FondInfo from "../Common/FondInfo";
import { useTrads } from "../../contexts/trads/useTrads";


function DemandesListComponent({params,setParams,show_user}:{params:DemandeParameters,show_user:boolean,setParams:React.Dispatch<React.SetStateAction<DemandeParameters>>}) {
    //const [curpage,setCurpage]=useState(0);
    console.log(params);
    //const [params,setParams]=useState<DemandeParameters>({...filtre,r:{...filtre.r},page:0, order:'', reverse:0});
    //console.log(params);
    const {translate}=useTrads();

    const { data, error, isLoading } = useLookupDemandesQuery(params);
    
    const setPage=function(page:number){
        setParams({...params,page: page})
    }
    const setOrder=function(order:string,reverse?:number){
        setParams({...params,order:order,reverse:reverse ?? 0});
    }
    
    //console.log(params);
    const statusClass=function(e:demandeStatus):string{
        if(e=='en_cours'){
            return "table-primary";
        }
        if(e=='accepte'){
            return "table-success"
        }
        if(e=='paye'){
            return "table-info"
        }
        if(e=='refuse'){
            return "table-danger"
        }
        /* eslint-disable @typescript-eslint/no-unnecessary-condition */
        if(e=='attente'){
            return "table-warning"
        }
        return "table-dark"
    }


    return (
 
            error ? (
               <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <>
                {data.pages>1? <Pager curpage={data.page} totalpages={data.pages} setter={setPage} /> :null}
                <table className="table table-hover">
                    <thead className="sticky-top">
                        <tr>
                            <th scope="col">
                                <div className="table-sort">
                                    {translate('demande_date_creation')}
                                    <div className={(params.order=='date_creation')?((params.reverse)?'desc':'asc'):undefined}>
                                        <a className='up' onClick={()=>{ setOrder('date_creation',1); }} ><i className="bi"></i></a>
                                        <a className='down' onClick={()=>{ setOrder('date_creation',0); }} ><i className="bi"></i></a>
                                    </div>
                                </div>
                                    
                            </th>
                            <th scope="col">{translate('demande_titre')}</th>
                            <th scope="col">
                                <div className="table-sort">
                                    {translate('demande_montant')}
                                    <div className={(params.order=='montant')?((params.reverse)?'desc':'asc'):undefined}>
                                        <a className='up' onClick={()=>{ setOrder('montant',1); }} ><i className="bi"></i></a>
                                        <a className='down' onClick={()=>{ setOrder('montant',0); }} ><i className="bi"></i></a>
                                    </div>
                                </div>
                                
                            </th>
                            {show_user?<th>{translate('demande_beneficiaire')}</th>:null}
                            <th scope="col">{translate('demande_fond')}</th>
                            <th scope="col">{translate('demande_comment')}</th>
                            <th scope="col">
                                <div className="table-sort">
                                    {translate('demande_statut')}
                                    <div className={(params.order=='statut')?((params.reverse)?'desc':'asc'):undefined}>
                                        <a className='up' onClick={()=>{ setOrder('statut',1); }} ><i className="bi"></i></a>
                                        <a className='down' onClick={()=>{ setOrder('statut',0); }} ><i className="bi"></i></a>
                                    </div>
                                </div>
                                
                            </th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.data.map((demande:Demande) => (
                        <tr key={demande.id}>
                            <td>{formatDate(demande.date_creation)}</td>
                            <td>{demande.titre}
                                <ul>
                                {demande.preuves.length?
                                    <li>{translate('demande_preuves')} 
                                        <ul>
                                        {demande.preuves.map((e)=>(
                                            <li key={e.filename}><span>{e.filename}</span></li>
                                        ))}
                                        </ul>
                                    </li>
                                :null}
                                {demande.justificatifs.length?
                                    <li>{translate('demande_justificatifs')} 
                                        <ul>
                                        {demande.justificatifs.map((e)=>(
                                            <li key={e.filename}><span>{e.filename}</span></li>
                                        ))}
                                        </ul>
                                    </li>
                                :null}
                                {demande.declarations.length?
                                    <li>{translate('demande_declarations')} 
                                        <ul>
                                        {demande.declarations.map((e)=>(
                                            <li key={e.filename}><span>{e.filename}</span></li>
                                        ))}
                                        </ul>
                                    </li>
                                :null}
                                </ul>
                            </td>
                            <td>{demande.montant}</td>
                            {show_user?
                                <td>
                                    {demande.inscription? 
                                        <ProfilDisplay inscription={demande.inscription} /> :
                                        <ProfilListItem userid={demande.id_inscription} />
                                    }
                                </td>
                            :null}

                            <td className={(!demande.fond_id)?"table-danger":undefined}>
                                {demande.fond_id?
                                    <FondInfo fondId={demande.fond_id}></FondInfo>:
                                    translate('demande_aucun_fond')
                                }
                            </td>
                            <td>{demande.comment}</td>
                            <td className={statusClass(demande.statut)}>{translate(demande.statut)}</td>
                            <td>
                                <NavLink to={`/demande/${demande.id.toString()}`}>
                                    <span className="visually-hidden">{translate('btn_voir')}</span>
                                    <i className="bi bi-eye-fill"></i>
                                </NavLink>
                            </td>
                        </tr>
                        ))}
                    </tbody>
                </table>
                {data.pages>1? <Pager curpage={data.page} totalpages={data.pages} setter={setPage} /> :null}
                </>
            ) : null
    );
}
export default DemandesListComponent;